module.exports = "https://static.zego.com/_next/static/images/CloseIcon-a08df79128d34bf0b80c0d001e30f9f8.svg";